import React from 'react'
import Footer from '../../components/Footer/Footer'
import ProfSignUpForm from '../../components/ProfessionalComponents/ProfSignUpForm/ProfSignUpForm'
import ProfBanner from '../../components/ProfessionalComponents/ProfBanner/ProfBanner'
import Header from '../../components/Navbar/Header'
import SelectRole from '../SelectRole'
import SecondHeader from '../../components/SecondHeader/SecondHeader'

const ProfSignUp = () => {
    return (
        <>
            {/* <Header /> */}
            <SecondHeader/>
            <ProfBanner />
            <SelectRole/>
            <ProfSignUpForm/>
            <Footer />
        </>
    )
}

export default ProfSignUp